
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { handleError, initClient } from '../../api';
import { formatDateTime } from '../../util';
import { Activity, ActivityControllerUIClient, ActivityPriority, Cell, CellClient, Duty, EnumStatus, Line, LineClient } from '../backend/backendapi';
import TabButton from '../util/TabButton';
import TabCell from './TabCell';
import TabInfo from './TabInfo';
import TabTasks from './TabTasks';
import { ListItem } from '../todolist/todolist.model';
import { getCheckListJson } from './util';

type Tabs = 'info' | 'tasks' | 'cell';
declare var window: WindowType;

@Component({
  components: {
    TabButton,
    TabCell,
    TabInfo,
    TabTasks,
  },
})
export default class ActivityModal extends Vue {
  @Prop({ required: true })
  readonly duty!: Duty;
  @Prop({ required: true })
  readonly activity!: Activity;
  @Prop({ required: true })
  readonly availableResponsibles!: ListItem[];
  @Prop({ required: true })
  readonly availablePriorities!: ActivityPriority[];
  @Prop({ required: true })
  readonly cells!: Cell[];

  tab: Tabs = 'info';
  cell: Cell | null = null;
  line: Line | null = null;

  //api
  private readonly activityAPI = initClient(ActivityControllerUIClient);
  private readonly cellAPI = initClient(CellClient);
  private readonly lineAPI = initClient(LineClient);

  formatDateTime = formatDateTime;

  get canComplete(): boolean {
    let json = getCheckListJson(this.activity, this.duty);
    const items = JSON.parse(json) as ListItem[];
    return items.every(e => !e.required || e.completed); //all required are completed
  }

  open(): void {
    this.tab = 'info';
    this.cell = null;
    this.line = null;
    $(this.$refs.modal!).modal('show');
  }

  dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async onComplete(): Promise<void> {
    if (!this.canComplete) {
      return;
    }

    try {
      this.activity.status = EnumStatus.Done;
      await this.activityAPI.updateActivity(this.activity);
      this.$toasted.info('Yay. Done!');
      this.dismiss();
      this.notifyChange();
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    }
  }

  async save(): Promise<void> {
    try {
      this.activity.status = EnumStatus.Changed;
      await this.activityAPI.updateActivity(this.activity);
      this.notifyChange();
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    }
  }

  onCellDetails(): void {
    this.cell = null;
    this.line = null;
    if (!!this.activity.cellId && this.activity.cellId > 0)
      this.loadCell(this.activity.cellId);
  }

  private async loadCell(id: number): Promise<void> {
    this.cell = await this.cellAPI.getCellData(id);
    if (this.cell?.lineId) {
      this.line = (await this.lineAPI.getLineData(this.cell.lineId)).result!;
    }
  }

  private notifyChange(): void {
    this.$emit('change');
  }

 private get isActivityDisableDetails(): boolean {
  return window.application.permissions.activity.disableDetails;
 }

  @Watch('tab')
  onTabChanged(newTab: Tabs): void {
    if (newTab === 'cell') {
      this.onCellDetails();
    }
  }
}
